import { FleekError } from './FleekError';

type GitProviderNotAuthorizedErrorOptions = {
  provider: string;
};

export class GitProviderNotAuthorizedError extends FleekError<GitProviderNotAuthorizedErrorOptions> {
  public name = 'GitProviderNotAuthorizedError';

  toString = () => `The user has not authorized the Git provider: ${this.data.provider}`;
}
